// extracted by mini-css-extract-plugin
module.exports = {"title":"logoList_title__Mtzpw","description":"logoList_description__nMZ5K","logos":"logoList_logos__ov9V7"};